import { render, staticRenderFns } from "./AnuladosList.vue?vue&type=template&id=15745b65&scoped=true&"
import script from "./AnuladosList.vue?vue&type=script&lang=js&"
export * from "./AnuladosList.vue?vue&type=script&lang=js&"
import style0 from "./List/styles.scss?vue&type=style&index=0&id=15745b65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15745b65",
  null
  
)

export default component.exports